<template>
    <div id="profile-page">
        <div class="page-heading">
            <h2 class="display-4 montserrat-bold mb-0">My Profile</h2>
            <div class="mt--2 heading-small">Manage your account information</div>
        </div>
        <card class="mb-5">
            <template slot="body">
                <h6 class="heading-small text-muted">Account Information</h6>
                <div class="row">
                    <div class="col-lg-10 col-sm-12 mb-3">
                        <div>
                            <div class="text-xs">Email</div>
                            <h3 class="font-weight-700 text-default text-sm" v-text="user.email"></h3>
                        </div>
                    </div>
                    <div class="col-sm-12">
                        <button class="btn bg-secondary text-dark shadow-reg" type="button" @click="showChangePasswordModal">
                            <i class="fas fa-lock mr-2"></i> Change password
                        </button>
                        <change-password-form ref="changePasswordForm" />
                    </div>
                </div>
            </template>
        </card>

        <profile-section ref="profileSection" @updated="profileUpdated" />

        <address-section ref="addressSection" @updated="addressUpdated" />

    </div>
</template>

<script>
import { default as store } from "../store/profile";
import ProfileSection from "./partials/ProfileSection";
import AddressSection from "./partials/AddressSection";
import ChangePasswordForm from "./partials/ChangePasswordForm";

export default {
    name: "ProfilePage",
    store,
    components: {
        ProfileSection, AddressSection, ChangePasswordForm,
    },

    computed: {
        user() {
            return this.$store.getters.account;
        }
    },

    methods: {
        initializeUser(customer) {
            this.$store.dispatch("setUser", { user: customer });
            this.$store.dispatch("setAddress", { address: customer.address });
            this.$refs.profileSection.initializeUser();
            this.$refs.addressSection.initializeAddress();
        },
        showChangePasswordModal() {
            this.$refs.changePasswordForm.show();
        },
        profileUpdated(customer) {
            this.$parent.customer = {...customer};
        },
        addressUpdated(address) {
            this.$parent.customer.address = {...address};
        }
    },

    props: {
        customer: [Object],
    },

    mounted() {
        this.$emit("mounted");
    }
}
</script>

<style lang="css" scoped>
    .page-heading {
        margin-bottom: 15px;
        padding: 0px 24px;
    }
</style>